import { IconButton } from '@mui/material';
import { Box } from '@mui/material';
import { memo, type ReactElement } from 'react';
import { useWaveSurfer, WaveSurferPlayerProps } from './useWaveSurfer';
import { FAIcon } from '@packages/ui-components';

const defaultWaveSurferProps = {
  waveColor: 'rgb(200, 0, 200)',
  progressColor: 'rgb(100, 0, 100)',
  barWidth: 2,
  barGap: 2,
  barRadius: 2,
  barHeight: 5,
  containerStyles: {},
  height: 45,
  width: '100%',
  playPauseButtonSx: {},
  containerSx: {},
  wavefHeight: 'auto',
  cursorWidth: 0,
};

const WavesurferPlayer = memo((props: WaveSurferPlayerProps): ReactElement => {
  const mergedProps = { ...defaultWaveSurferProps, ...props };
  const {
    containerRef,
    // isReady,
    isPlaying,
    currentTime,
    togglePlayPause,
    formatTime,
  } = useWaveSurfer(mergedProps);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        ...mergedProps.containerSx,
      }}
    >
      {/* {isReady && ( */}
      <IconButton
        onClick={togglePlayPause}
        sx={{
          ...mergedProps.playPauseButtonSx,
        }}
      >
        {isPlaying ? (
          <FAIcon icon="faPauseCircle" size={37} />
        ) : (
          <FAIcon icon="faPlayCircle" size={37} />
        )}
      </IconButton>
      {/* )} */}

      <div ref={containerRef} style={{ width: '100%' }} />
      {/* {isReady &&   */}
      <p>{formatTime(currentTime)}</p>
      {/* } */}
    </Box>
  );
});

export default WavesurferPlayer;
